<template>
  <v-card>
    <v-card-title class="headline">
      Expenses by period

      <v-spacer />

      <v-btn-toggle
        v-model="timeBase"
        mandatory
        @change="aggregateData"
      >
        <v-btn
          text
          value="month"
        >
          M
        </v-btn>
        <v-btn
          text
          value="quarter"
        >
          Q
        </v-btn>
        <v-btn
          text
          value="year"
        >
          Y
        </v-btn>
      </v-btn-toggle>
    </v-card-title>

    <div>
      <apexcharts
        type="bar"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'
import Apexcharts from 'vue-apexcharts'

import { sortBy } from '@/utils'

const TIME_BASES = {
  month: {
    format: 'YYYY-MM',
    unit: 'month',
    count: 1
  },
  quarter: {
    format: 'YYYY-[Q]Q',
    unit: 'month',
    count: 3
  },
  year: {
    format: 'YYYY',
    unit: 'year',
    count: 1
  }
}

export default {
  components: {
    Apexcharts
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      timeBase: 'month',
      series: [],
      chartOptions: {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '40%'
          }
        },
        dataLabels: {
          enabled: false
        },
        yaxis: {
          labels: {
            formatter: val => this.$options.filters.fmtCurrency(val)
          },
          title: { text: 'Expenses' }
        },
        tooltip: {
          y: {
            formatter: val => this.$options.filters.fmtCurrency(val)
          }
        }
      }
    }
  },
  watch: {
    data (val) {
      this.aggregateData()
    }
  },
  mounted () {
    // this.seriesEstimated = this.chart.series.push(new am4charts.LineSeries())
    // this.seriesEstimated.dataFields.dateX = 'time'
    // this.seriesEstimated.dataFields.valueY = 'cost'
    // this.seriesEstimated.tooltipText = 'Planned: [bold]{valueY}[/]'
    // this.seriesEstimated.fillOpacity = 0.3

    // this.seriesActuals = this.chart.series.push(new am4charts.LineSeries())
    // this.seriesActuals.dataFields.dateX = 'time'
    // this.seriesActuals.dataFields.valueY = 'cost'
    // this.seriesActuals.tooltipText = 'Actuals: [bold]{valueY}[/]'
    // this.seriesActuals.fillOpacity = 0.3

    this.aggregateData()
  },
  methods: {
    aggregateData (costProp, timeProp) {
      const PROPS = [
        [ 'cost', 'date' ],
        [ 'actualCost', 'actualDate' ]
      ]
      let grouped = {}

      for (let expense of this.data) {
        for (let [cost, time] of PROPS) {
          if (expense[time]) {
            const k = moment(expense[time])
              .startOf('month')
              .format(TIME_BASES[this.timeBase].format)

            if (!grouped[k]) { grouped[k] = { time: k } }

            grouped[k][cost] = (grouped[k][cost] || 0) + (expense[cost] || 0)
          }
        }
      }

      // for (let date in grouped) {
      //   grouped[date] = {
      //     time: moment.utc(date, TIME_BASES[this.timeBase].format).toDate(),
      //     cost: sumBy(grouped[date], costProp)
      //   }
      // }

      grouped = Object.values(grouped).sort(sortBy('time'))

      this.series = [
        {
          name: 'Cost',
          data: grouped.map(x => x[PROPS[0][0]] || 0)
        }
        // {
        //   name: 'Actuals',
        //   data: grouped.map(x => x[PROPS[1][0]] || 0)
        // }
      ]

      this.chartOptions = {
        xaxis: {
          categories: grouped.map(x => x.time)
        }
      }
    }
  }
}
</script>

<style>

</style>
